import type { SxProps, Theme } from '@portals/core/src/themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    footerContainer: {
      backgroundColor: theme.palette.secondary.darker,
    },
    outerContainer: {
      marginTop: 8,
    },
    innerContainer: {
      rowGap: 0,
      padding: 0,
      display: {
        lg: 'flex',
        md: 'flex',
      },
    },
    gridItem: {
      whiteSpace: 'nowrap',
    },
    divider: {
      display: {
        xs: 'block',
        lg: 'none',
        md: 'none',
      },
    },
    articleText: {
      width: '100%',
      alignSelf: 'center',
      color: theme.palette.grey.A400,
      marginTop: {
        xs: 7,
        lg: 1,
      },
    },
  };
};
